import { useTranslation } from 'react-i18next';
import { useReglagesRdv, useTypesRdv } from '../../api/priseRendezVous.js';
import { galerieALaction, galerieAModule } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { TypesListe } from '../rendez-vous-en-ligne/TypesListe.js';
import { ExceptionsListe } from '../rendez-vous-en-ligne/ExceptionsListe.js';
import { ReglagesGeneraux } from '../rendez-vous-en-ligne/ReglagesGeneraux.js';
import { ApercuCreneaux } from '../rendez-vous-en-ligne/ApercuCreneaux.js';
import { ErreurRdv } from '../rendez-vous-en-ligne/ErreurRdv.js';
import styles from '../rendez-vous-en-ligne/RendezVous.module.css';

export function RendezVousEnLignePage() {
  const { galerieSlug, galerie, compte } = useShellContext();
  const { t } = useTranslation(['regie', 'commun']);
  const autorise =
    galerieAModule(galerie, 'prise-rendez-vous') && galerieALaction(galerie, 'creneaux:configurer');
  const types = useTypesRdv(galerieSlug, autorise);
  const reglages = useReglagesRdv(galerieSlug, autorise);
  if (!autorise) return <p role="alert">{t('regie:priseRendezVous.interdit')}</p>;
  return (
    <div className={styles.page}>
      <h1>{t('regie:priseRendezVous.titre')}</h1>
      <p>{t('regie:priseRendezVous.reglagesDescription')}</p>
      {types.isLoading || reglages.isLoading ? <p role="status">{t('commun:chargement')}</p> : null}
      <ErreurRdv erreur={types.error ?? reglages.error} />
      {types.data && reglages.data ? (
        <div key={`${compte.id}:${galerieSlug}`} className={styles.formulaire}>
          <TypesListe types={types.data.types} />
          <ExceptionsListe types={types.data.types} fuseau={reglages.data.reglages.fuseau} />
          <ReglagesGeneraux reglages={reglages.data.reglages} />
          <ApercuCreneaux
            key={reglages.data.reglages.fuseau}
            types={types.data.types}
            fuseau={reglages.data.reglages.fuseau}
          />
        </div>
      ) : null}
    </div>
  );
}
